import { GridContainerSt as GridContainer } from './index.css';

export { GridContainer };

GridContainer.name = 'GridContainer';
